class Services {
    constructor(element) {
        this.container = typeof (element) === 'string' ? document.querySelector(element) : element;
    }

    init() {
        this.tiles = Array.from(this.container.querySelectorAll('.tile'));
        if (Foundation.MediaQuery.atLeast('medium')) {
            this.tiles.forEach(tile => {
                var hiddenBlock = tile.querySelector('.hidden-block');
                hiddenBlock.style.display = 'block';
                hiddenBlock.style.marginBottom = -hiddenBlock.clientHeight + 'px';
                tile.addEventListener('mouseenter', () => {
                    if (!tile._timeline) {
                        var icon = tile.querySelector('.icon');
                        var hiddenBlock = tile.querySelector('.hidden-block');
                        hiddenBlock.style.display = 'block';
                        tile._timeline = gsap.timeline()
                            .addLabel('start')
                            .to(icon, { marginTop: -(icon.clientHeight + parseInt(getComputedStyle(icon).marginBottom)), autoAlpha: 0, duration: .3 })
                            .to(hiddenBlock, { autoAlpha: 1, marginBottom: 0, duration: .3 }, 'start');
                    }
                    else {
                        tile._timeline.play();
                    }
                });
                tile.addEventListener('mouseleave', () => {
                    tile._timeline.reverse();
                })
            });
        }
    }
}

export { Services as default };